module.exports = __webpack_public_path__ + "img/28.2721efd7.jpg";